<div *ngIf="isMobile">
  <h5 class="mobile-nav-title" i18n>Add Quote</h5>
  <div class="mb-5 mx-3">
    <app-project-info-mobile projectType="quote" [customerId]="customerId"></app-project-info-mobile>
  </div>
</div>

<div *ngIf="!isMobile" class="container-fluid">
  <app-header titleText="QUOTES" i18n-titleText progressBarState="quote"></app-header>

  <div class="card bg-light">
    <div class="card-header">
      <img src="assets/img/circle_images/quotes_circle.png" alt="Customer Icon" class="card-icon" />
      <span i18n>Add New Quote</span>
      <p i18n>Set up a new quote below. Please note:  quotes must have an established customer set up for a quote.</p>
    </div>
    <div class="card-body">
      <app-project-info projectType="quote" [customerId]="customerId"></app-project-info>
    </div>
  </div>
</div>
